// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"p_b2","modalDialog":"p_b2","modal-title":"p_b3","modalTitle":"p_b3","modal-subtitle":"p_b4","modalSubtitle":"p_b4"};